import api from "../utils/api";
import { useEffect, useCallback } from "react";
import { CHAVE_TOKEN } from "../utils/formata";

// Chamadas da aba Equipe (gestão de usuários — admin only)
export default function useEquipe() {
  // Garante o header no F5 (mesmo padrão do useHelp — sem isso dá 401)
  useEffect(() => {
    const token = localStorage.getItem(CHAVE_TOKEN);
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
    }
  }, []);

  const listarUsuarios = useCallback(async () => {
    return api.get("/usuario").then((r) => r.data.usuarios);
  }, []);

  const criarUsuario = useCallback((dados) => {
    return api.post("/usuario/add", dados).then((r) => r.data);
  }, []);

  const atualizarUsuario = useCallback((id, dados) => {
    return api.put(`/usuario/${id}`, dados).then((r) => r.data);
  }, []);

  const removerUsuario = useCallback((id) => {
    return api.delete(`/usuario/${id}`).then((r) => r.data);
  }, []);

  return { listarUsuarios, criarUsuario, atualizarUsuario, removerUsuario };
}
